import { Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import MoneyWithCurrency from 'modules/core/lib/money'

interface AmountWithCurrencyProps {
  amount: number
  currency: string
}

const AmountWithCurrency = ({ amount, currency }: AmountWithCurrencyProps): JSX.Element => {
  const value = Math.abs(amount)

  const {
    access: { locale },
  } = useCurrentSession()

  const amountWithCurrency = MoneyWithCurrency({
    amount: value,
    currency,
    locale,
  })

  return (
    <Text weight="normal" size="300" color="grey800">
      {amountWithCurrency}
    </Text>
  )
}

export default AmountWithCurrency
